export default {
  // TimeAllocation specific texts
  includeInTotalHours: 'Include in {totalHours}',
  hourType: 'Hour Type',
  pedagogical: 'Pedagogical',
  chronological: 'Chronological',
  attendanceRequired: 'Required attendance %',
  attendanceRequiredDefault: 'Required attendance % (Default Value)',
  studentsPerHour: 'No. of students',
  studentsPerHourDefault: 'No. of students (Default Value)',
  attendanceValidation: 'This field must be greater than or equal to zero and less than or equal to 100.',
  orderValidation: 'This field must be greater than or equal to zero and less than or equal to 100.',
  associateWith: 'Associate with {entity}',
  yes: 'YES',
  no: 'NO',
  noApply: 'DOES NOT APPLY',
  includeInTotalHoursDefault: 'Include in Total Hours (Default Value)',
  requiredForTeacherProfiles: 'This object is necessary for the functioning of teacher profiles.',
  requiredForDidacticBriefcase: 'This object is necessary for the functioning of the didactic briefcase.',
}
